import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=16afa0bc&scoped=true"
import script from "./NoPermission.vue?vue&type=script&lang=js"
export * from "./NoPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afa0bc",
  null
  
)

export default component.exports